// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue3289(props) {
    return (
        <svg
            id="_x33_289"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n\t.st16{fill:none;stroke:#B3B3B3;stroke-width:0.25;stroke-miterlimit:10;}\n"
                }
            </style>
            <g id="NYM">
                <g id="compass">
                    <path
                        className="st0"
                        d="M229.6,208.1l-4.2-8.2l-0.8-7.9l3.9,6.9L229.6,208.1z"
                    />
                    <path
                        className="st1"
                        d="M231.7,214.3c-8.1,2.6-16.9-1.9-19.5-10s1.9-16.9,10-19.5s16.9,1.9,19.5,10 C244.4,202.9,239.9,211.7,231.7,214.3z M222.7,186c-7.5,2.4-11.6,10.4-9.2,17.8s10.4,11.6,17.8,9.2c7.5-2.4,11.6-10.4,9.2-17.8 C238.1,187.7,230.1,183.6,222.7,186z"
                    />
                    <path
                        className="st0"
                        d="M228.4,196.9c1.5,0.8,2,2.5,1.3,4c-0.8,1.5-2.5,2-4,1.3c-1.5-0.8-2-2.5-1.3-4S226.9,196.1,228.4,196.9z  M223,191.1l-0.9-2.9l0.4-0.1l2,1.6l-0.6-2l0.5-0.2l0.9,2.9l-0.4,0.1l-2-1.6l0.6,2L223,191.1z"
                    />
                    <path
                        className="st2"
                        d="M227.8,198.1c0.8,0.4,1.1,1.4,0.7,2.2c-0.4,0.8-1.4,1.1-2.2,0.7c-0.8-0.4-1.1-1.4-0.7-2.2 C226,198,227,197.6,227.8,198.1z"
                    />
                </g>
                <g id="distances">
                    <text
                        id="right"
                        transform="matrix(1 0 0 1 225.6533 114.5732)"
                        className="st3 st4 st5"
                    >
                        330
                    </text>
                    <text
                        id="right-right-center_1_"
                        transform="matrix(1 0 0 1 62.8115 54.1855)"
                        className="st3 st4 st5"
                    >
                        370
                    </text>
                    <text
                        id="right-center_1_"
                        transform="matrix(1 0 0 1 158.0547 44.0811)"
                        className="st3 st4 st5"
                    >
                        380
                    </text>
                    <text
                        id="center"
                        transform="matrix(1 0 0 1 116.4346 29.8398)"
                        className="st3 st4 st5"
                    >
                        408
                    </text>
                    <text
                        id="left-center_1_"
                        transform="matrix(1 0 0 1 171.5967 54.186)"
                        className="st3 st4 st5"
                    >
                        370
                    </text>
                    <text
                        id="left-left-center_1_"
                        transform="matrix(1 0 0 1 21.8096 79.4854)"
                        className="st3 st4 st5"
                    >
                        358
                    </text>
                    <text
                        id="left"
                        transform="matrix(1 0 0 1 5.165 113.0767)"
                        className="st3 st4 st5"
                    >
                        335
                    </text>
                </g>
                <g id="field" transform="matrix(.98 0 0 -.98 250 420)">
                    <path
                        id="Outfield_00000094597754240764042730000018294815217055423873_"
                        className="st6"
                        d="M-26.2,318.5L-26.2,318.5l-37.4-37.7 l-5.4-28.5c0,0-22.6-33-28.4-39.5c-7.9-11.7-21.6-12.8-29.2-12.8c-12.3,0-22.5,2-31.3,13.3l-28.2,38.6l-7.6,30.8l-35.9,35.8 l1.8,3.3l1.2,2.3l1.2,2.3l1.2,2.4l1.3,2.4l1.2,2.5l1.3,2.5l1.3,2.5l1.3,2.5l1.3,2.6l2.1,1.6l2.2,1.5l2.2,1.5l2.2,1.5l2.3,1.4 l2.2,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.3,1.4l2.4,1.4l2.4,1.5l2.4,1.6 l2.4,1.7l2.4,1.7l2.5,1.7l2.5,1.7l2.5,1.8l2.6,1.8l2.6,1.8l2.7,1.8l2.7,1.9l2.8,1.9l2.8,2l2.9,1.6h3h3.1h3h3h3h3h3.1l3-0.5 l2.9-1.8l2.8-1.7l2.8-1.7l2.8-1.6l2.7-1.6l2.7-1.6l2.6-1.6l2.6-1.5l2.5-1.6l2.5-1.5l2.5-1.5l2.5-1.5l2.4-1.5l2.5-1.4l2.4-1.5 l2.4-1.4l2.4-1.4l2.4-1.4l2.8-0.5l2.8-0.6l2.8-0.5l2.4-1.4l1.7-2.7l1.7-2.5l1.7-2.5l1.7-2.4l1.7-2.4l1.7-2.3l1.6-2.3l1.6-2.3 l1.6-2.3l1.6-2.2l1.5-2.2l1.5-2.2l1.5-2.1l1.5-2.1l1.5-2.1l1.4-2.1l1.4-2.1l1.4-2l1.4-2L-26.2,318.5z"
                    />
                    <path
                        id="grass_1_"
                        className="st3"
                        d="M-126.5,208.1c-10.9-0.1-18.1,1.4-24.8,9.8l-27.7,36.8l-8.1,31.3l-33.9,32.9l9.2,18.6l0.5,0.4 l6.2,4.5l2,1.3l29.9,18.7l2.6,1.6l30.3,21.8l0.7,0.4l18.6,0.2l0.8-0.1l43.2-25.1l3.3-1.9l6.3-1.7l2.7-0.7l20.1-28l2.6-3.8l3.7-5.1 l-33.4-34.6l-5.1-29.4c-8.8-13.2-22.5-33.2-26.3-37.6l-0.4-0.4l-0.3-0.5C-108.3,211.4-115.5,208.3-126.5,208.1L-126.5,208.1z"
                    />
                    <path
                        id="infield_sand"
                        className="st6"
                        d="M-87.9,258.5l-1,1c-5.1,16.3-20.4,28.3-38.5,28.3s-33.4-11.9-38.5-28.3l-1-1l33.4-33.4 c-0.5-0.9-0.7-2-0.7-3.1c0-3.8,3.1-6.8,6.8-6.8s6.8,3.1,6.8,6.8c0,1.1-0.3,2.1-0.7,3.1L-87.9,258.5z M-130.1,270.7 c0.8-0.5,1.8-0.8,2.8-0.8s2,0.3,2.8,0.8l17.1-17.1c-1.6-1.6-1.6-4.2,0-5.7l2.6-2.6l-18-18c-1.2,1-2.7,1.6-4.4,1.6 s-3.2-0.6-4.4-1.6l-18,18l2.6,2.6c1.6,1.5,1.6,4.1,0,5.7L-130.1,270.7z"
                    />
                </g>
                <g id="persistent">
                    <g id="mound">
                        <path
                            id="pitching-mound"
                            className="st6"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                        />
                        <path
                            id="pitching-rubber"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4V176.6z"
                        />
                    </g>
                    <g id="lines">
                        <path
                            id="left-foul-line_2_"
                            className="st8"
                            d="M125.2,203.2l-98.7-98.6"
                        />
                        <path
                            id="right-foul-line"
                            className="st8"
                            d="M125.2,203.2l97.1-97.2"
                        />
                    </g>
                    <g id="bases_2_">
                        <rect
                            id="third-base_2_"
                            x={99.2}
                            y={175.1}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="first-base_2_"
                            x={148.1}
                            y={175.2}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="second-base_2_"
                            x={123.7}
                            y={148.6}
                            transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)"
                            className="st10"
                            width={3}
                            height={3}
                        />
                        <polygon
                            id="home_2_"
                            className="st7"
                            points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                        />
                    </g>
                </g>
            </g>
            <g id="grid" className="st11">
                <g className="st12">
                    <g id="numbers">
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)"
                            className="st4 st13"
                        >
                            90
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)"
                            className="st4 st13"
                        >
                            200
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)"
                            className="st4 st13"
                        >
                            150
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)"
                            className="st4 st13"
                        >
                            120
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)"
                            className="st4 st13"
                        >
                            250
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)"
                            className="st4 st13"
                        >
                            300
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)"
                            className="st4 st13"
                        >
                            350
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)"
                            className="st4 st13"
                        >
                            400
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)"
                            className="st4 st13"
                        >
                            450
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)"
                            className="st4 st13"
                        >
                            500
                        </text>
                    </g>
                    <g id="surface29_2_">
                        <path className="st14" d="M125.5,203.8l-148-148" />
                        <path className="st14" d="M124.8,203.8l148-148" />
                        <path className="st15" d="M125.1,203.5L45.4,10.9" />
                        <path className="st15" d="M125.1,203.5V-4.9" />
                        <path className="st15" d="M125.1,203.5l79.8-192.6" />
                    </g>
                    <path
                        id="_x31_00-line"
                        className="st14"
                        d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                    />
                    <path
                        id="_x32_00-line_2_"
                        className="st14"
                        d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
                    />
                    <path
                        id="_x39_0-line_2_"
                        className="st14"
                        d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
                    />
                    <path
                        id="_x31_20-line"
                        className="st14"
                        d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
                    />
                    <path
                        id="_x32_50-line"
                        className="st14"
                        d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
                    />
                    <path
                        id="_x33_00-line"
                        className="st14"
                        d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                    />
                    <path
                        id="_x33_50-line"
                        className="st14"
                        d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
                    />
                    <path
                        id="_x34_50-line"
                        className="st14"
                        d="M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
                    />
                    <path
                        id="_x34_00-line_1_"
                        className="st14"
                        d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
                    />
                    <path
                        id="_x35_00-line"
                        className="st14"
                        d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
                    />
                </g>
                <g className="st12">
                    <rect
                        x={125.2}
                        y={16}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={18}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={20.1}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={22.2}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={24.3}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={26.3}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={28.4}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={30.5}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={32.6}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={34.6}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                </g>
            </g>
        </svg>
    )
}
export default Venue3289
